export const USER_ROLE = {'SUPER_ADMIN': 'SUPER_ADMIN', 'ROLE_GENERAL_ADMIN':'ROLE_GENERAL_ADMIN', 'ROLE_GENERAL_SELL':'ROLE_GENERAL_SELL'}